import { render } from "./MyFire.vue?vue&type=template&id=e42ad27a&scoped=true&ts=true"
import script from "./MyFire.vue?vue&type=script&lang=ts"
export * from "./MyFire.vue?vue&type=script&lang=ts"

import "./MyFire.vue?vue&type=style&index=0&id=e42ad27a&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e42ad27a"]])

export default __exports__